export function branchLastActivity(branch: {
  lastChatEntryAt: number | null;
  lastRunAt: number | null;
  createdAt: number;
}): number {
  return Math.max(
    branch.lastChatEntryAt ?? 0,
    branch.lastRunAt ?? 0,
    branch.createdAt
  );
}
